import { render, staticRenderFns } from "./NaBreadcrumbButton.component.vue?vue&type=template&id=584a3bcc&scoped=true&"
import script from "./NaBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./NaBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./NaBreadcrumbButton.component.vue?vue&type=style&index=0&id=584a3bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a3bcc",
  null
  
)

export default component.exports